module.exports = __webpack_public_path__ + "img/988834772a350f49a659f83eb0daa317.png";